import React, { useEffect, useRef, useState } from "react";
import MapComponent from "../../Reusablecomponents/MapComponent";
import {
  Badge,
  Card,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Form,
  Row,
  Tree,
} from "antd";
import styled from "styled-components";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import { Tab } from "../../Reusablecomponents/Tab";
import { ReactComponent as LiveTrackTwo } from "../../assets/livetracking/livetracktwo.svg";
import { ReactComponent as LiveTrackThree } from "../../assets/livetracking/livetrackthree.svg";
import { ReactComponent as LiveTrackFour } from "../../assets/livetracking/livetrackfour.svg";
import { ReactComponent as LiveTrackFive } from "../../assets/livetracking/livetrackfive.svg";
import { ReactComponent as LiveTrackSix } from "../../assets/livetracking/livetracksix.svg";
import { ReactComponent as LiveTrackSeven } from "../../assets/livetracking/livetrackseven.svg";
import { ReactComponent as LiveTrackEight } from "../../assets/livetracking/livvetrackingeight.svg";
import { ReactComponent as LiveTracknine } from "../../assets/livetracking/livetrackingnine.svg";
import { ReactComponent as LiveTrackten } from "../../assets/livetracking/livetrackingten.svg";
import { ReactComponent as LiveTrackone } from "../../assets/livetracking/livetrackone.svg";
import { ReactComponent as LiveTrackeleven } from "../../assets/livetracking/trackwrighteleven.svg";
import { ReactComponent as LiveTracksixteen } from "../../assets/livetracking/trackrightsixteen.svg";
import { ReactComponent as LiveTrackthirteen } from "../../assets/livetracking/trackrightthirteen.svg";
import { ReactComponent as LiveTracktwelve } from "../../assets/livetracking/trackwrighttwelve.svg";
import { ReactComponent as LiveTrackfourteen } from "../../assets/livetracking/trackrightfourteen.svg";
import { ReactComponent as Stationary } from "../../../src/assets/livetracking/stationary.svg";
import { ReactComponent as Moving } from "../../../src/assets/livetracking/moving.svg";
import { ReactComponent as Bidconineteen } from "../../../src/assets/livetracking/bidconineteen.svg";
import { ReactComponent as Containertrackingnumber } from "../../../src/assets/livetracking/containertrackingnumber.svg";
import { ReactComponent as Containertrackingnumbertwo } from "../../../src/assets/livetracking/containertrackingnumbertwo.svg";
import { ReactComponent as Calecontainertrackingnumberthree } from "../../../src/assets/livetracking/containertrackingnumberthree.svg";
import { ReactComponent as Calender } from "../../assets/livetracking/calender.svg";

import {
  AimOutlined,
  ContainerOutlined,
  DownOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { Slider, Button } from "antd";
import {
  StepBackwardOutlined,
  StepForwardOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  ExpandOutlined,
} from "@ant-design/icons";
import Trackingplayback from "../../../src/containers/LiveTrack/Trackingplayback";
import TrackingPlayBackMap from "../../Reusablecomponents/TrackingPlayBackMap";
const { DirectoryTree } = Tree;

const LiveTrackStyle = styled.div`
  .datepickerss {
    display: block !important;
  }

  .vechicle_number {
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .numbers_containers {
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
  }
  .card_container_four .ant-card-body {
    padding: 3px !important;
  }
  .card_container_four.ant-card-bordered {
    border-radius: 55px !important;
  }
  .card_container_four {
    width: 700px;
    height: auto;
    position: absolute;
    top: 62%;
    left: 31%;
    z-index: 20;
    background-color: #ffffff;
  }
  .card_container_three {
    width: 100%;
    height: auto;
    position: absolute;
    top: 85%;
    left: 1%;
    z-index: 20;
    background-color: transparent !important;
    padding: 4px 4px 4px 4px !important;
  }
  .styled_table_coustomization {
  }
  .container_iteme {
    background-color: #f1f1f1;
    display: flex;
    align-items: center;
    gap: 30px;
    margin-left: 15px;
    padding: 15px;
    border-radius: 20px;
  }
  .ant-tree-iconEle.ant-tree-icon__customize {
    display: none !important;
  }
  /* .ant-tree .ant-tree-indent-unit::before {
  border-right: 1px dotted #999; 
   border-radius: 0 !important;  
   margin-left :0px
}
.ant-tree .ant-tree-switcher::before {
  border-top: 1px dotted #999;
   border-radius: 0 !important; 
} */

  .ant-tree .ant-tree-indent-unit::before,
  .ant-tree .ant-tree-switcher::before {
    z-index: 2 !important;
    position: relative;
  }

  /* node content below line */
  .ant-tree .ant-tree-node-content-wrapper {
    position: relative;
    z-index: 1; /* text/icons under line */
  }

  .container_three {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 25px;
  }
  .liveTrackMap_container_two {
    width: 100%;
    height: 1200px !important;
    /* position: relative; */
  }
  .container_componentmap {
    width: 100%;
    height: 100vh !important;
    position: relative;
  }
  .card_container {
    width: 450px;
    height: 780px;
    position: absolute;
    top: 1%;
    left: 3%;
    z-index: 20;
    background-color: #ffffff;
  }
  .card_container_two {
    width: 400px;
    height: 780px;
    position: absolute;
    top: 1%;
    right: 1%;
    z-index: 20;
    background-color: #ffffff;
  }
  .ant-card-bordered {
    border: none !important;
    border-radius: 20px !important;
  }
  .left-section {
    flex: 1;
  }

  .right-section {
    margin-left: auto;
  }
  .map_container_one {
    display: flex;
    gap: 35px;
    align-items: center;
    padding: 5px 3px 10px 3px;
    border-top: 1px solid #ececec;
  }
  .map_container_two {
    display: flex;
    gap: 15px;
    flex-direction: column;
  }
  .map_container_four {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .map_container_three {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .map_conatiner_five {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .container_six {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: space-between;
  }
  .map_container_itemstwo {
    border-top: 1px solid #ececec;
  }
  .map_container_checkbox_two {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }
  .mapbox_online_icon {
    color: green;
  }
  .numbers_containers {
    font-family: Inter;
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 14px;
  }
  .map_container_threeitem {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
  }
  map_container_threeitem_subtwo {
    background-color: green;
  }
  .map_container_suitem {
    display: flex;
    justify-content: space-between;
    gap: 4px;
  }
  .map_containersubheading {
    display: flex;
    flex-direction: column;
    gap: 15px;
    /* border-bottom:1px solid #dadada; */
  }
  .subcontainer_one {
    display: flex;
    gap: 05px;
  }
  .subcontainer_two {
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding-bottom: 10px;
    margin-top: 9px;
  }
  .subcontainer_three {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .map_container_checkboxsubcontainer {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    margin-top: 5px;
  }
  /* vertical spacing between nodes */
  .ant-tree .ant-tree-treenode {
    margin: 6px 0;
    padding: 4px 0;
  }
  .ant-tree .ant-tree-indent-unit {
    width: 0px; /* default ~16px, increase for more horizontal space */
  }
`;

const Trackinghistory = ({ totalPoints = 100, onPositionChange }) => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cardopen, setCardopen] = useState();

  const AddEditForm = {
    pages: [
      {
        fields: [
          [
            {
              id: "recipiententitytype",
              type: "selectwithvalue",
              name: "recipiententitytype",
              options: []
                ?.filter((item) => item.value !== "")
                .map((item) => ({
                  label: item?.name,
                  value: item?.value,
                })),
              mode: "multiple",
              validationRules: [
                {
                  required: true,
                  message: "Recipient Entity type is required",
                },
              ],
            },
          ],
        ],
        colSpan: [4],
      },
    ],
  };
  const itemsTwo = [
    {
      key: 1,
      checkboxes: <Checkbox />,
      total: "100 Total",
      online: "40 Online",
      offline: "60 Offline",
      moving: "12 moving",
    },
    {
      key: 2,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackone />,
      name: "KAA112",
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTrackSeven />,
      location: <LiveTrackSix />,
    },
    {
      key: 3,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackFour />,
      name: "KAA112",
      roundedicon: <LiveTrackTwo />,
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTrackSeven />,
      location: <LiveTrackSix />,
    },
    {
      key: 4,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackone />,
      name: "KAA112",
      roundedicon: <LiveTrackTwo />,
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTrackEight />,
      location: <LiveTrackSix />,
    },
    {
      key: 5,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackFour />,
      name: "KAA112",
      roundedicon: <LiveTrackTwo />,
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTracknine />,
      location: <LiveTrackSix />,
    },
  ];
  const itemsone = [
    {
      key: 1,
      checkboxes: <Checkbox />,
      total: "100 Total",
      online: "40 Online",
      offline: "60 Offline",
      moving: "12 moving",
    },
    {
      key: 2,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackFour />,
      name: "KAA112",
      roundedicon: <LiveTrackTwo />,
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTrackSeven />,
      location: <LiveTrackSix />,
    },
    {
      key: 3,
      checkboxone: <Checkbox />,
      TruckICON: <LiveTrackFour />,
      name: "KAA112",
      roundedicon: <LiveTrackTwo />,
      roundediconOne: <LiveTrackFive />,
      movingIcon: <LiveTrackSeven />,
      location: <LiveTrackSix />,
    },
  ];
  const cardOpen = () => {
    setCardopen(true);
  };
  const All = () => {
    const treeData = [
      {
        title: (
          <>
            <Bidconineteen />
          </>
        ),
        key: "0-0",
        icon: null,
        children: [
          {
            title: (
              <>
                <div style={{ display: "flex", gap: "15px" }}>
                  <span>
                    <Containertrackingnumber />
                  </span>
                  <span className="numbers_containers" onClick={cardOpen}>
                    KAA 123A (5615261734)
                  </span>
                </div>
              </>
            ),
            key: "0-0-0",
            icon: <ContainerOutlined />,
          },
          {
            title: (
              <>
                <div style={{ display: "flex", gap: "15px" }}>
                  <span>
                    <Containertrackingnumbertwo />
                  </span>
                  <span className="numbers_containers" onClick={cardOpen}>
                    KAA 123A (5615261734)
                  </span>
                </div>
              </>
            ),
            key: "0-0-1",
            icon: <AimOutlined />,
          },
          {
            title: (
              <>
                <div style={{ display: "flex", gap: "15px" }}>
                  <span>
                    <Containertrackingnumbertwo />
                  </span>
                  <span className="numbers_containers" onClick={cardOpen}>
                    KAA 123A (5615261734)
                  </span>
                </div>
              </>
            ),
            key: "0-0-2",
            icon: <AimOutlined />,
          },
        ],
      },
      //   {
      //     title: "KPM Tech Solutions",
      //     key: "0-1",
      //     icon: <FolderOpenOutlined />,
      //   },
    ];

    const onSelect = (selectedKeys, info) => {
    };
    return (
      <>
        <Row>
          <Col xl={24} xxl={24}>
            <div className="left-section">
              <LiveTrackten className="livetrackingdropdown_icon" />
            </div>
          </Col>
          <Col xl={24} xxl={24}>
            <div style={{ marginTop: "20px" }} className="left_section">
              <DirectoryTree
                multiple
                defaultExpandAll
                treeData={treeData}
                showLine={{ showLeafIcon: false }}
                itemHeight={40}
              />
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const itemsfour = [
    {
      key: 1,
      checkboxes: <Checkbox />,
      total: "100 Total",
      online: "40 Online",
      offline: "60 Offline",
      moving: "12 moving",
    },
    {
      key: 2,
      headingiCON: <LiveTrackeleven />,
    },
    {
      key: 3,
      headingICONe: <LiveTracktwelve />,
    },
    {
      key: 4,
      checkboxtwo: <Checkbox />,
      TruckICON: <LiveTrackone />,
      name: "6216388101 (KAA 112)",
      roundedicon: <LiveTracksixteen />,
      fouteen: <LiveTrackfourteen />,
      thirteen: <LiveTrackthirteen />,
    },
  ];

  const data = [
    {
      total: "100 Total",
      online: "40 Online",
      offline: "60 Offline",
      moving: "12 moving",
      company: "Bidco",
      headinglogo: <LiveTrackeleven />,
      checkboxthree: <Checkbox />,
      bidcologo: <LiveTracktwelve />,
      totalVehicles: 4,
      vehicles: [
        {
          id: "6216388101",
          regNo: "KAA 112",
          status: "Stationary",
          battery: "19%",
          lock: "Locked",
          checkboxthree: <Checkbox />,
          stationary: <Stationary />,
          LiveTrackone: <LiveTrackone />,
          roundediconOne: <LiveTrackFive />,
        },
        {
          id: "6216388101",
          regNo: "KAA 112",
          status: "Moving",
          battery: "86%",
          lock: "Unlocked",
          checkboxthree: <Checkbox />,
          stationary: <Moving />,
          LiveTrackone: <LiveTrackone />,
          roundediconOne: <LiveTrackFive />,
        },
        {
          id: "6216388101",
          regNo: "KAA 112",
          status: "Stationary",
          battery: "19%",
          lock: "Unlocked",
          checkboxthree: <Checkbox />,
          stationary: <Moving />,
          LiveTrackone: <LiveTrackone />,
          roundediconOne: <LiveTrackFive />,
        },
      ],
    },
    {
      company: "General Cargo Services",
      checkboxthree: <Checkbox />,
      bidcologo: <LiveTracktwelve />,
      headinglogo: <LiveTrackeleven />,
      totalVehicles: 2,
      vehicles: [
        {
          id: "6216388101",
          regNo: "KAA 112",
          status: "Stationary",
          battery: "19%",
          lock: "Locked",
          checkboxthree: <Checkbox />,
          LiveTrackone: <LiveTrackone />,
          stationary: <Moving />,
          roundediconOne: <LiveTrackFive />,
        },
        {
          id: "6216388101",
          regNo: "KAA 112",
          status: "Idle",
          battery: null,
          lock: "Unlocked",
          checkboxthree: <Checkbox />,
          LiveTrackone: <LiveTrackone />,
          stationary: <Moving />,
          roundediconOne: <LiveTrackFive />,
        },
      ],
    },
  ];

  const TrackrightAi = () => {
    const [ischecked, setisChecked] = useState(false);
    const [checked, setChecked] = useState([]);

    const clickcheckbox = (e) => {
    };
    return (
      <>
        <Row>
          <Col xl={24} xxl={24}>
            <div className="left-section">
              <LiveTrackten className="livetrackingdropdown_icon" />
            </div>
            <div>
              {data.map((item, index) => {
                return (
                  <>
                    <div>
                      <div className="map_container_checkboxsubcontainer">
                        <div onclick={clickcheckbox}>{item?.checkboxes}</div>
                        <div className="numbers_containers">{item?.total}</div>
                        <div className="mapbox_online_icon numbers_containers">
                          {item?.online}
                        </div>
                        <div className="numbers_containers">
                          {item?.offline}
                        </div>
                        <div className="mapbox_online_icon numbers_containers">
                          {item?.moving}
                        </div>
                      </div>
                      <div>
                        <div>{item.bidcologo}</div>
                      </div>
                      <div>
                        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                          {item?.headinglogo}
                        </div>
                        <div>
                          {item.vehicles.map((val, i) => {

                            return (
                              <>
                                <div className="subcontainer_two">
                                  <div>
                                    <div>{item.checkboxthree}</div>
                                  </div>
                                  <div className="subcontainer_three">
                                    <div className="subcontainer_one">
                                      <div>{val.LiveTrackone}</div>
                                      <div>
                                        {val.id}
                                        {`${val.regNo}`}
                                      </div>
                                      <div>{val.LiveTracksixteen}</div>
                                      <div>{val.LiveTracksixteen}</div>
                                      <div>{val.LiveTracksixteen}</div>
                                      <div>{val.roundediconOne}</div>
                                    </div>
                                    <div>{val.stationary}</div>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </Col>
        </Row>
      </>
    );
  };
  const TrackrightAiCargo = () => {
    return (
      <>
        <Row>
          <Col xl={24} xxl={24}>
            <div className="left-section">
              {/* <GridBuilder
                        formStructureJson={AddEditForm}
                        formSubmit={handleSubmitForm}
                        initialValues={formData}
                        form={form}
                        handleSelectChange={handleSelectChange}
                      /> */}
              <LiveTrackten className="livetrackingdropdown_icon" />
            </div>
            <div style={{ backgroundColor: "" }}>
              {itemsTwo.map((item, index) => {
                return (
                  <>
                    <div key={index} className="map_container_itemstwo">
                      <div className="map_container_checkbox_two">
                        <div>{item?.checkboxes}</div>
                        <div className="numbers_containers">{item?.total}</div>
                        <div className="mapbox_online_icon numbers_containers">
                          {item?.online}
                        </div>
                        <div className="numbers_containers">
                          {item?.offline}
                        </div>
                        <div className="mapbox_online_icon numbers_containers">
                          {item?.moving}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0px",
                        }}
                      >
                        <div style={{ display: "flex", gap: "20px" }}>
                          <div>{item?.checkboxone}</div>
                          <div>{item?.TruckICON}</div>
                          <div className="vechicle_number">{item?.name}</div>
                          <div>{item?.roundediconOne}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center gap-2 p-2">
                          {item?.movingIcon}
                          <div>{}</div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const items = [
    {
      key: "All",
      label: "All",
      children: (
        <>
          <All />
        </>
      ),
    },
    {
      key: "TrackRight AI",
      label: "TrackRight AI",
      children: (
        <>
          <TrackrightAi />
        </>
      ),
    },
    {
      key: "TrackRight AI Cargo",
      label: "TrackRight AI Cargo",
      children: (
        <>
          <TrackrightAiCargo />
        </>
      ),
    },
  ];
  const [tableOpen, SetTableOpen] = useState(false);
  const tableclose = () => {
    SetTableOpen(true);
  };
  const cardclosedd = () => {
    SetTableOpen(false);
  };

  const [isdatepickeropen, setIsDatePickerOpen] = useState(false);
  const datePickerRef = useRef(null);
  const handleIconClick = () => {
    setIsDatePickerOpen((prev) => { 
      return ( !prev 

    )});
  };
  const [datepicker , setDatepicker] = useState(null)
  const handledatepickerchange = (date, dateString) => {
    setDatepicker(dateString)
    const routesvaal = routePoints.find((item) =>
       {
        return   item?.datetime === dateString   })
    ;
    setDatepicker(routesvaal)
      const  newlatlng = {routelat:  routesvaal?.lat ,   routelng :routesvaal?.lng };

  }

const [routePoints, setRoutePoints] = useState([])

  const itemscontainer = [
    {
      key: "All",
      label: (
        <>
          <div onClick={tableclose}>Today</div>
        </>
      ),
      children: (
        <>
          <div style={{}}
           ref={datePickerRef} 
          className="container_iteme"
          >
            <div className="datepickerss">
              <Calender
              onClick={handleIconClick}
                style={{ width: "35px", height: "35px", cursor: "pointer" }}
              />
          {isdatepickeropen &&   <DatePicker   onChange={handledatepickerchange}  style={{marginLeft: "12px", cursor: "pointer" }} />}  
            </div>
          
          </div>
          <div></div>
        </>
      ),
    },
    {
      key: "TrackRight AI",
      label: "Last Week",
      children: <></>,
    },
    {
      key: "TrackRight AI Cargo",
      label: "Last 15 days",
      children: <></>,
    },
  ];

  const cardclose = () => {
    // setCardopen(false);
  };

  const columns = [
    { title: "Index", dataIndex: "index", key: "index" },
    { title: "GPS Time", dataIndex: "gpsTime", key: "gpsTime" },
    { title: "Receive Time", dataIndex: "receiveTime", key: "receiveTime" },
    {
      title: "Positioning State",
      dataIndex: "positioningState",
      key: "positioningState",
    },
    { title: "Speed (Km/h)", dataIndex: "speed", key: "speed" },
    { title: "Mileage (Km)", dataIndex: "mileage", key: "mileage" },
    { title: "Battery", dataIndex: "battery", key: "battery" },
    { title: "Satellite Signal", dataIndex: "satellite", key: "satellite" },
    { title: "GSM Signal", dataIndex: "gsm", key: "gsm" },
    { title: "Location", dataIndex: "location", key: "location" },
  ];
  const Trackinglinkdata = [
    {
      key: "1",
      index: 1,
      gpsTime: "2025-09-17 10:15:30",
      receiveTime: "2025-09-17 10:15:35",
      positioningState: "Active",
      speed: 60,
      mileage: 125.4,
      battery: "85%",
      satellite: "Strong",
      gsm: "Good",
      location: "Mumbai, India",
    },
    {
      key: "2",
      index: 2,
      gpsTime: "2025-09-17 10:20:10",
      receiveTime: "2025-09-17 10:20:15",
      positioningState: "Idle",
      speed: 0,
      mileage: 128.1,
      battery: "78%",
      satellite: "Medium",
      gsm: "Average",
      location: "Navi Mumbai, India",
    },
    {
      key: "3",
      index: 3,
      gpsTime: "2025-09-17 10:25:00",
      receiveTime: "2025-09-17 10:25:05",
      positioningState: "Moving",
      speed: 45,
      mileage: 135.6,
      battery: "72%",
      satellite: "Weak",
      gsm: "Poor",
      location: "Pune, India",
    },
  ];
  const TrackPoints = () => {
    return <></>;
  };
  const Alarms = () => {
    return <></>;
  };
  const itemsTrackrightpoints = [
    {
      key: "All",
      label: "All",
      children: (
        <>
          <TrackPoints />
        </>
      ),
    },
    {
      key: "TrackRight AI",
      label: "TrackRight AI",
      children: (
        <>
          <Alarms />
        </>
      ),
    },
  ];
  const [markerIndex, setMarkerIndex] = useState(0);
  const [routePosition, setRoutePosition] = useState([])


useEffect(()=>{
  setRoutePosition(routePoints?.[markerIndex])
},[markerIndex])

  return (
    <>

      <LiveTrackStyle>
        <Row>
          <Col style={{ position: "relative" }} xl={24} xxl={24}>
            <div className="container_componentmap">
               <TrackingPlayBackMap routePosition={routePosition} setRoutePoints={setRoutePoints} actualLocationsAI={[
    {
        "StartLat": "-1.2598477",
        "StartLng": "36.8036998",
        "EndLat": "-1.3519515",
        "EndLng": "36.9056237",
    }
]}

/>
              {/* <MapComponent
              actualLocationsAI={[
    {
        "StartLat": "-1.2598477",
        "StartLng": "36.8036998",
        "EndLat": "-1.3519515",
        "EndLng": "36.9056237",
    }
]}
                className="liveTrackMap_container_two"
                trackLink={true}
                containerDetailMap={""}
                conatinericon={true}
              /> */}

              <div>
                <Card
                  className="card_container"
                  headStyle={{ display: "none" }}
                >
                  <div className="container_three"></div>
                  <Row>
                    <Col>
                      <div className="custom_dashboard_ai">
                        <Tab
                          className="custom_dashboard_ai_tab"
                          items={items}
                          defaultActiveKey="TrackRight AI+"
                        />
                      </div>
                    </Col>
                  </Row>
                </Card>
                {cardopen === true && (
                  <Card
                    onClick={cardclose}
                    className="card_container_two"
                    headStyle={{ display: "none" }}
                  >
                    <Tab
                      className="custom_dashboard_ai_tab"
                      items={itemscontainer}
                      defaultActiveKey="TrackRight AI+"
                    />
                  </Card>
                )}
                {cardopen && (
                  <>
                    <Card
                      onClick={cardclosedd}
                      className="card_container_three"
                      headStyle={{ display: "none" }}
                    >
                      <StyledTable
                        className="styled_table_coustomization"
                        columns={columns}
                        dataSource={Trackinglinkdata}
                        pagination={false}
                      />
                      ;
                    </Card>
                  </>
                )}

                {cardopen === true && (
                  <Card
                    className="card_container_four"
                    headStyle={{ display: "none" }}
                  >
                    {" "}
                    <div style={{ padding: "20px" }}>
                      {/* Map placeholder */}
                      <div
                        style={{
                          height: "auto",
                          background: "#f5f5f5",
                          marginBottom: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                        }}
                      >
                        {/* Marker at: {routePoints[markerIndex]?.lat},{" "}
                        {routePoints[markerIndex]?.lng} */}
                      </div>

                      {/* Playback Controller */}
                      <Trackingplayback
                        totalPoints={routePoints.length}
                        onPositionChange={setMarkerIndex}
                      />
                    </div>
                  </Card>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </LiveTrackStyle>
    </>
  );
};

export default Trackinghistory;
